import { useRef, useEffect } from "react"
import { useFormContext } from "react-hook-form"
import isPostalCode from "validator/lib/isPostalCode"
import getInputValidationClasses from "../../../lib/helpers/getInputValidationClasses"
import { input } from "../../common/form/input.module.css"
import Label from "../../common/form/label"
import { ErrorMessage } from "../errorMessage"
import { useUserDetails } from "../store"

function EditUserDetails() {
  const { userDetails } = useUserDetails()
  const { zip } = userDetails
  const { setValue } = useFormContext()

  useEffect(() => {
    const fields = ["firstName", "lastName", "address", "zip", "city"]
    fields.forEach((field) => {
      const value = userDetails[field] || ""
      setValue(field, value, { shouldValidate: false, shouldDirty: false })
    })
  }, [userDetails, setValue])

  return (
    <>
      <div className="flex flex-col w-full px-3 mb-3 sm:w-1/2 lg:mb-6">
        <EditDetail name="firstName" label="Förnamn" />
      </div>
      <div className="flex flex-col w-full px-3 mb-3 sm:w-1/2 lg:mb-6">
        <EditDetail name="lastName" label="Efternamn" />
      </div>

      <div className="flex flex-col w-full px-3 mb-3 lg:mb-6">
        <EditDetail name="address" label="Gatuadress" />
      </div>

      <div className="flex flex-col w-full px-3 mb-3 sm:w-1/2 lg:mb-6">
        <EditDetail
          name="zip"
          label="Postnummer"
          validationRules={{
            required: true,
            validate: (value) =>
              zip === value ||
              isPostalCode(value, "SE") ||
              "Ange ett giltigt postnummer."
          }}
        />
      </div>
      <div className="flex flex-col w-full px-3 mb-3 sm:w-1/2 lg:mb-6">
        <EditDetail name="city" label="Ort" />
      </div>
    </>
  )
}

function EditDetail({ name, label, validationRules = { required: true } }) {
  const { userDetails } = useUserDetails()

  const { watch, register, setValue, control } = useFormContext()

  const valueRef = useRef(userDetails[name] || "")
  const watchValue = watch(name)

  return (
    <>
      <Label required={true} name={name}>
        {label}
      </Label>
      <input
        id={name}
        {...register(name, validationRules)}
        className={[input, getInputValidationClasses(name, control)].join(" ")}
        onFocus={() => {
          if (watchValue === valueRef.current) {
            setValue(name, "")
          }
        }}
        defaultValue={userDetails[name]}
        onBlur={() => {
          if (watchValue === "") {
            setValue(name, valueRef.current, { shouldValidate: true })
          }
        }}
      />
      <ErrorMessage name={name} />
    </>
  )
}

export default EditUserDetails
